import * as fromDatatype from '../datatype-library/index';

export interface app_perm_set_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  parent_guid: fromDatatype.GuidDataFieldInterface;
  type: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  target_type: fromDatatype.VarcharDatatypeInterface;
  target_policy_json: fromDatatype.JsonDatatypeInterface;
  target_filter_json: fromDatatype.JsonDatatypeInterface;
  target_options_json: fromDatatype.JsonDatatypeInterface;
  target_hdr_table: fromDatatype.VarcharDatatypeInterface;
  target_hdr_guid: fromDatatype.GuidDataFieldInterface;
  target_line_table: fromDatatype.VarcharDatatypeInterface;
  target_line_guid: fromDatatype.GuidDataFieldInterface;
  operation_options_json: fromDatatype.JsonDatatypeInterface;
  operation_default_json: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class app_perm_set_line_RowClass implements app_perm_set_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  parent_guid: fromDatatype.GuidDataFieldInterface;
  type: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  target_type: fromDatatype.VarcharDatatypeInterface;
  target_policy_json: fromDatatype.JsonDatatypeInterface;
  target_filter_json: fromDatatype.JsonDatatypeInterface;
  target_options_json: fromDatatype.JsonDatatypeInterface;
  target_hdr_table: fromDatatype.VarcharDatatypeInterface;
  target_hdr_guid: fromDatatype.GuidDataFieldInterface;
  target_line_table: fromDatatype.VarcharDatatypeInterface;
  target_line_guid: fromDatatype.GuidDataFieldInterface;
  operation_options_json: fromDatatype.JsonDatatypeInterface;
  operation_default_json: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
